export const rateFromBp = (bp) => bp / 100;
export class OfferRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async replaceAll(rows) {
        await this.driver.batch([
            { sql: 'DELETE FROM offer_items' },
            { sql: 'DELETE FROM offers' },
            ...rows.map((o) => ({
                sql: `INSERT INTO offers
                (id, name, type, sort_order, is_active, category_id, buy_qty, free_qty, set_qty,
                 set_price_paise, percent_off_bp, combo_price_paise, min_ticket_paise, max_per_ticket,
                 starts_on, ends_on, days_of_week, start_minute, end_minute)
              VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                params: [
                    o.id,
                    o.name,
                    o.type,
                    o.sortOrder,
                    o.isActive ? 1 : 0,
                    o.categoryId,
                    o.buyQty,
                    o.freeQty,
                    o.setQty,
                    o.setPricePaise,
                    o.percentOffBp,
                    o.comboPricePaise,
                    o.minTicketPaise,
                    o.maxPerTicket,
                    o.startsOn,
                    o.endsOn,
                    JSON.stringify(o.daysOfWeek),
                    o.startMinute,
                    o.endMinute,
                ],
            })),
            ...rows.flatMap((o) => o.items.map((item) => ({
                sql: `INSERT INTO offer_items (offer_id, menu_item_id, quantity) VALUES (?, ?, ?)`,
                params: [o.id, item.menuItemId, item.quantity],
            }))),
        ]);
    }
    async listActive() {
        const [offers, items] = await Promise.all([
            this.driver.query({
                sql: 'SELECT * FROM offers WHERE is_active = 1 ORDER BY sort_order, id',
            }),
            this.driver.query({ sql: 'SELECT * FROM offer_items' }),
        ]);
        const itemsByOffer = new Map();
        for (const row of items) {
            const offerId = String(row.offer_id);
            const list = itemsByOffer.get(offerId) ?? [];
            list.push({ menuItemId: String(row.menu_item_id), quantity: Number(row.quantity) });
            itemsByOffer.set(offerId, list);
        }
        return offers.map((o) => ({
            id: String(o.id),
            name: String(o.name),
            type: String(o.type),
            sortOrder: Number(o.sort_order),
            items: itemsByOffer.get(String(o.id)) ?? [],
            categoryId: o.category_id == null ? null : String(o.category_id),
            buyQty: o.buy_qty == null ? null : Number(o.buy_qty),
            freeQty: o.free_qty == null ? null : Number(o.free_qty),
            setQty: o.set_qty == null ? null : Number(o.set_qty),
            setPrice: o.set_price_paise == null ? null : Number(o.set_price_paise),
            percentOff: o.percent_off_bp == null ? null : rateFromBp(Number(o.percent_off_bp)),
            comboPrice: o.combo_price_paise == null ? null : Number(o.combo_price_paise),
            minTicket: o.min_ticket_paise == null ? 0 : Number(o.min_ticket_paise),
            maxPerTicket: o.max_per_ticket == null ? 0 : Number(o.max_per_ticket),
            startsOn: o.starts_on == null ? null : String(o.starts_on),
            endsOn: o.ends_on == null ? null : String(o.ends_on),
            daysOfWeek: parseDaysOfWeek(o.days_of_week),
            startMinute: o.start_minute == null ? null : Number(o.start_minute),
            endMinute: o.end_minute == null ? null : Number(o.end_minute),
        }));
    }
}
function parseDaysOfWeek(raw) {
    if (typeof raw !== 'string')
        return [];
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.map(Number) : [];
    }
    catch {
        return [];
    }
}
//# sourceMappingURL=offers.js.map